import { render } from "./Vehicule.vue?vue&type=template&id=874a4116&scoped=true"
import script from "./Vehicule.vue?vue&type=script&lang=js"
export * from "./Vehicule.vue?vue&type=script&lang=js"

import "./Vehicule.vue?vue&type=style&index=0&id=874a4116&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874a4116"]])

export default __exports__